exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".renderer-container {\r\n    font-size: 13px;\r\n}\r\n.renderer-default {\r\n    margin-top: 2px;\r\n    text-overflow: ellipsis;\r\n    display: block;\r\n    overflow: hidden;\r\n    -webkit-user-select: text;\r\n       -moz-user-select: text;\r\n        -ms-user-select: text;\r\n            user-select: text;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/pallet-management/pallet-management-inventory/account-num-cell-renderer/account-num-cell-renderer.component.css
// module id = ../../../../../src/app/features/inventory/pallet-management/pallet-management-inventory/account-num-cell-renderer/account-num-cell-renderer.component.css
// module chunks = main